import { cycloneApiClient } from '@/shared/api/core/axios-instance';

import type { ProjectsExperimentsResponse } from '@/entities/experiment';

export type GetProjectsExperimentsParams = {
  query?: string;
};

export const getProjectsExperiments = async (
  params?: GetProjectsExperimentsParams
): Promise<ProjectsExperimentsResponse> => {
  try {
    const response = await cycloneApiClient.get<ProjectsExperimentsResponse>('/projects/tree', { params });
    return response.data;
  } catch (error) {
    console.warn('[getProjectsExperiments] API 호출 실패:', error);
    return { projects: [] };
  }
};
